import { addListener } from "cluster";
import * as $ from 'jquery';

export class FileInputCommon {

    private files = [];
    private inputSrc = '';

    static getError(file, attributes) {
        let error = { min: false, max: false, accepted : false };
        if (attributes['data-min-size']) {
            let min = attributes['data-min-size'].value * 1024 * 1024;
            if (min && file.size <= min) {
                error.min = true;
            }
        }
        if (attributes['data-max-size']) {
            let max = attributes['data-max-size'].value * 1024 * 1024;
            if (max && file.size >= max) {
                error.max = true;
            }
        }
        if (attributes['data-accept']) {
            let allowedFiles = attributes['data-accept'].value.split('|');
            for ( let index in allowedFiles ) {
                allowedFiles[index] = '.' + allowedFiles[index];
            }
            let regex = new RegExp("([a-zA-Z0-9\s_\\.\-:])+(" + allowedFiles.join('|') + ")$");
            if (!regex.test(file.name.toLowerCase())) {
                error.accepted = true;
            }
        }
        return error;
    }

    static getListItem(idx, file, attributes, name) {
        let error = FileInputCommon.getError(file, attributes);
        let text = `<li><div><span class="file-name"><i class="material-icons">insert_drive_file</i>&nbsp;${file.name}</span></div><div>${FileInputCommon.addCopyrightInput(attributes, name, idx)}</div></li>`;
        if (error.min) {
            let errorMsg = attributes['data-min-size-error'] && attributes['data-min-size-error'].value ? attributes['data-min-size-error'].value : 'Error, minimum file size is not reached!';
            text = `<li class="error"><div><span class="file-name"><i class="material-icons">error</i>&nbsp;${file.name}</span> <span class="error">${errorMsg}</span><div></li>`;
        }
        if (error.max) {
            let errorMsg = attributes['data-max-size-error'] && attributes['data-max-size-error'].value ? attributes['data-max-size-error'].value : 'Error, file size exceeds limit!';
            text = `<li class="error"><div><span class="file-name"><i class="material-icons">error</i>&nbsp;${file.name}</span> <span class="error">${errorMsg}</span><div></li>`;
        }
        if (error.accepted) {
            text = `<li class="error"><div><span class="file-name"><i class="material-icons">error</i>&nbsp;${file.name}</span> <span class="error">File extension is not supported!</span><div></li>`;
        }
        return text;

    }

    static addCopyrightInput(attributes, fileInput, idx) {
        return (attributes['data-show-copyright'] && attributes['data-show-copyright'].value == 'true') ? `<div><input type="text" name="${fileInput}_copyright_${idx}"></div>` : '';
    }


    static validate(elem) {
        let input = $(elem);
        let files = input.prop("files");
        input.attr('data-dirty', 'true');
        let comp = input.closest('.file-uploader-component');
        if (comp.length > 0) {
            let attributes = comp.get(0).attributes;

            let i = 0;
            if (files.length > 0) {
                let error = { min: false, max: false };
                do {
                    error = FileInputCommon.getError(files[i], attributes);
                    i++;
                }
                while (i < files.length && !error.min && !error.max);
                return !(error.min || error.max);
            }
        }
        return true;
    }

    static reset(form) {
        $(`form[name=${form}] .file-uploader-component`).each((i, comp) => {
            $(comp).find('input').val('');
            $(comp).find('.copyright-title').hide();
        })
    }

    static addList(elem) {
        let input = $(elem);
        let comp = input.closest('.file-uploader-component');
        let files = input.prop("files");
        let name = input.attr('name');
        let list = comp.find("ul.files-list");
        list.html("");
        let attributes = $(comp).get(0).attributes;
        if (attributes['data-show-copyright'] && attributes['data-show-copyright'].value == 'true') {
            comp.find('.copyright-title').show().text('Copyright information');
        }
        else {
            comp.find('.copyright-title').hide();
        }
        $.each(files, (idx, file) => {
            let text = FileInputCommon.getListItem(idx, file, attributes, name);
            list.append(text);
        });

    }

    static initFileUpload(comp) {
        let c = $(comp);
        let input = c.find('input[type="file"]');
        c.off("click", "button.file-select");
        c.on("click", "button.file-select", () => input.click()),
        // @ts-ignore
            c.off("change", input.get(0));
        c.on("change", input.get(0), e => {
            if ($(e.target).attr('type') == 'file')
                FileInputCommon.addList(input);
        });
    }
}